import axiosInstance from './axiosInstance';

const getAdminByUuid = (uuid) => {
  return axiosInstance.get(`/internal/admin/admins/${uuid}`);
};

export default getAdminByUuid;
